import React from "react";
// @mui-icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import Quote from "components/Typography/Quote.js";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// import Muted from "components/Typography/Muted.js";
// import CardFooter from "components/Card/CardFooter.js";
// import CardActionArea from '@mui/material/CardActionArea';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
// import Typography from "@mui/material/Typography";

import styles from "./ServicesSections.module.scss";

export default function SectionText() {
  return (
    <div className={styles.containerWide}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={6} md={4} lg={2}>
          <Card style={{ maxWidth: "400px", height: "85%" }}>
            <img
              className={styles.imgCardTop}
              src="/img/services/images/search-engine-marketing-small.webp"
              alt="search-engine-marketing"
            />
            <CardBody>
              <p className={styles.description}>
                We've implemented state of the art search campaigns for many clients including shopping ads and offline data feeds. Check out our work
              </p>
              <br />
              <a href="/services/google-ads-services">
                <Button color="primary" style={{ position: "absolute", left: "10px", bottom: "10px" }}>
                  Find out more
                </Button>
              </a>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

